import React from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from '../styles/staticPages.js';
import Parallax from "components/Parallax/Parallax";
import { useSelector } from "react-redux";

const dashboardRoutes = [];
const useStyles = makeStyles(styles);

export default function PrivacyPolicy(props) {
  const classes = useStyles();
  const settings = useSelector(state => state.settingsdata.settings);
  const appName = "ENMI Remolque";
  const companyName = (settings && settings.CompanyName) ? settings.CompanyName : "ENMI Remolque App Solutions";
  const supportEmail = (settings && settings.contact_email) ? settings.contact_email : "ecuestreelrincon@gmail.com";
  const companyWebsite = (settings && settings.CompanyWebsite) ? settings.CompanyWebsite : "https://transport-caballos.web.app";
  const deleteAccountUrl = `${companyWebsite.replace(/\/$/, "")}/delete-account`;
  const { ...rest } = props;

  const sectionStyle = {
    marginTop: "32px",
  };

  const titleStyle = {
    marginTop: 0,
    marginBottom: "12px",
    color: "#383838",
    fontSize: "1.45rem",
    fontWeight: 700,
  };

  const listStyle = {
    marginTop: "8px",
    marginBottom: 0,
    paddingLeft: "20px",
    color: "#383838",
  };

  return (
    <div style={{ margin: "-8px" }}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg").default} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <br />
          <h2 style={{ textAlign: "left", position: "relative", marginTop: "30px", minHeight: "32px", color: "#383838", textDecoration: "none" }}>
            Política de privacidad
          </h2>

          <p className={classes.description}>
            Esta Política de Privacidad aplica a <strong>{appName}</strong>, la aplicación móvil y el sitio web operados por <strong>{companyName}</strong>.
          </p>
          <p className={classes.description}>
            El sitio web de la aplicación está disponible en{" "}
            <a href={companyWebsite} target="_blank" rel="noopener noreferrer">
              <strong>{companyWebsite}</strong>
            </a>.
          </p>
          <p className={classes.description}>
            Al usar <strong>{appName}</strong>, aceptas la recopilación y el uso de información de acuerdo con esta política.
          </p>
          <p className={classes.description}>
            La información que recopilamos se utiliza únicamente para operar la aplicación, brindar soporte al usuario y mejorar el servicio.
          </p>

          <section style={sectionStyle}>
            <h3 style={titleStyle}>Información que recopilamos</h3>
            <ul style={listStyle}>
              <li>Nombre, correo electrónico y número de teléfono.</li>
              <li>Datos de perfil y datos necesarios para crear y gestionar la cuenta.</li>
              <li>Ubicación aproximada y precisa, incluida la ubicación en segundo plano cuando la aplicación está en uso para prestar el servicio.</li>
              <li>Información relacionada con solicitudes o uso de la aplicación.</li>
              <li>Mensajes o solicitudes enviadas a soporte por correo electrónico.</li>
            </ul>
          </section>

          <section style={sectionStyle}>
            <h3 style={titleStyle}>Cómo usamos la información</h3>
            <ul style={listStyle}>
              <li>Para crear y administrar cuentas de usuario.</li>
              <li>Para permitir el uso normal de la aplicación.</li>
              <li>Para mostrar, coordinar y dar seguimiento a solicitudes de servicio según la ubicación del usuario o del conductor.</li>
              <li>Para responder consultas y solicitudes de soporte.</li>
              <li>Para mantener la seguridad y el funcionamiento del servicio.</li>
            </ul>
          </section>

          <section style={sectionStyle}>
            <h3 style={titleStyle}>Compartición de información</h3>
            <p className={classes.description}>
              No vendemos tus datos personales. No usamos redes sociales externas ni proveedores de autenticación social dentro de la aplicación.
              Solo utilizamos correo electrónico y número de teléfono como medios de contacto y verificación relacionados con la cuenta.
            </p>
          </section>

          <section style={sectionStyle}>
            <h3 style={titleStyle}>Eliminación de cuenta</h3>
            <p className={classes.description}>
              Puedes eliminar tu cuenta desde la página de perfil en la aplicación móvil. Abre la app, entra a tu perfil, selecciona <strong>Eliminar cuenta</strong> y confirma la solicitud.
            </p>
            <p className={classes.description}>
              Al confirmar la eliminación, se eliminan los datos asociados a tu cuenta de nuestros sistemas, incluyendo tu información de perfil y los registros relacionados con la cuenta.
            </p>
            <p className={classes.description}>
              Si no puedes acceder a la app, puedes solicitar la eliminación escribiendo a{" "}
              <a href={`mailto:${supportEmail}`}>
                <strong>{supportEmail}</strong>
              </a>.
            </p>
            <p className={classes.description}>
              También puedes revisar las instrucciones en{" "}
              <a href={deleteAccountUrl} target="_blank" rel="noopener noreferrer">
                <strong>{deleteAccountUrl}</strong>
              </a>.
            </p>
          </section>

          <section style={sectionStyle}>
            <h3 style={titleStyle}>Seguridad</h3>
            <p className={classes.description}>
              Tomamos medidas razonables para proteger tu información personal. Aun así, ningún método de transmisión o almacenamiento electrónico es completamente seguro.
            </p>
          </section>

          <section style={sectionStyle}>
            <h3 style={titleStyle}>Contacto</h3>
            <p className={classes.description}>
              Si tienes preguntas sobre esta política, puedes escribir a{" "}
              <a href={`mailto:${supportEmail}`}>
                <strong>{supportEmail}</strong>
              </a>.
            </p>
          </section>
          <br />
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
}
